import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Imgs } from "../../../img/Imgs/Imgs";
import { selectInv } from "../../../store/slices/invitationSlice";
import { useSelector } from "react-redux";
import Loader from "../../Loader/Loader";
import { selectedLanguage } from "../../../store/slices/selectedLanguageSlice";
import translations from "../../../language.json";



const Events = () => {
  const { pathname } = useLocation();
  const lastSegment = pathname.split("/").filter(Boolean).pop();
  const { dataInv, isLoading } = useSelector(selectInv);
  const [delayedLoading, setDelayedLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  const safeData = Array.isArray(dataInv) ? dataInv : [];
  const totalPages = Math.ceil(safeData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = safeData.slice(startIndex, startIndex + itemsPerPage);
  const selectedLanguages = useSelector(selectedLanguage);
  const goToPage = (page) => setCurrentPage(page);

  useEffect(() => {
    if (!isLoading) {
      const timeout = setTimeout(() => {
        setDelayedLoading(false);
      }, 1500);

      return () => clearTimeout(timeout);
    } else {
      setDelayedLoading(true);
    }
  }, [isLoading]);

  return (
    <div className="web-temp container">
      <h2>{translations[selectedLanguages]?.templatesMain[lastSegment]}</h2>
      {delayedLoading ? (
        <Loader />
      ) : (
        <div className="website-templates-most-watched">
          {currentItems?.length === 0 ? (
            <h1>Coming soon...</h1>
          ) : (
            currentItems.map((el, index) => (
              <a href={el.url} key={index} rel="noopener noreferrer">
                <div
                  className="phone-box"
                  style={{
                    backgroundImage: `url(${el.image})`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  {el.text3 && (
                    <div className="phone-box__sale">
                      <img src={Imgs.sale_icon} alt="sale" />
                      <span>{el.text3}</span>
                    </div>
                  )}
                  <img className="phone-png" src={Imgs.iphone} alt="" />
                </div>
                <p>
                  code: <span>{el.code}</span>
                </p>
                <div className="inv__price">
                  <p>
                    price: <span className={el.text3 ? "underline" : ""}>{el.text1}</span>
                  </p>
                  {el.text3 && <span className="sale-price">{el.text2}</span>}
                </div>
              </a>
            ))
          )}
        </div>
      )}
      {totalPages > 1 && (
        <div className="pagintaion">
          {Array.from({ length: totalPages }, (_, i) => (
            <button key={i} onClick={() => goToPage(i + 1)} className={currentPage === i + 1 ? "active" : ""}>
              {i + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Events;
